import { FitViewOptions, useReactFlow } from '@xyflow/react';
import { useCallback } from 'react';

import { useViewportTransform } from '@/components/diagrams/FlowChart/hooks/useViewportTransform';

import { FamilyTreeEffectFn, FitViewEffect } from '../types';

export function useFitViewEffect(): FamilyTreeEffectFn<FitViewEffect> {
  const { fitView } = useReactFlow();
  const { getTransform } = useViewportTransform();

  return useCallback<FamilyTreeEffectFn<FitViewEffect>>(
    (state, { opts, perserveZoomLevel }, _dispatch) => {
      const currentZoom = getTransform()[2];
      const preservedZoomLevelOpts: FitViewOptions = {
        minZoom: currentZoom,
        maxZoom: currentZoom,
      };

      // Filter out synthetic nodes so they are not included in the fit view calculation
      const nodesToFit = state.nodes.filter((node) => {
        if (node.type === 'person') {
          return !node.data.person.isSynthetic;
        }
        return true;
      });

      const finalOpts = {
        ...opts,
        ...(perserveZoomLevel && preservedZoomLevelOpts),
        nodes: nodesToFit,
      };

      void fitView(finalOpts);
    },
    [fitView, getTransform]
  );
}
